<!--
 * @Author: linhui.zhang
 * @Date: 2020-03-10 11:19:24
 * @LastEditTime: 2020-04-30 10:21:14
 * @LastEditors: Please set LastEditors
 * @Description: In User Settings Edit
 * @FilePath: \gta_aitraining_vue\src\views\personal\teacher\TeacherPersonal.vue
 -->
<!-- 作业页面 -->
<template>
  <div class="publish-list-section">
    <gat-head
      :openLogin="isLogin"
      @cancelLogin="doCancelLogin"
      @confirmLogin="doConfirmlLogin"
      ref="loginfirst"
    ></gat-head>
    <!--tab-->
    <div class="nav-bg"></div>
    <div class="content">
      <div class="back-button" @click="onBack"><i class="icon-back"></i>返回</div>
      <el-tabs
        class="list-tabs"
        type="card"
        v-model="activeName"
        @tab-click="handleClick"
      >
        <el-tab-pane label="已提交" name="first">
          <ul class="published-list">
            <li
              class="list-item"
              v-for="(student, index) in studentList"
              :key="index"
              @click="toScore(student)"
            >
              <div class="left-side">
                <img v-if="student.photo" :src="/^(https?:\/\/)/.test(student.photo) ? student.photo : photoBaseUrl + student.photo" />
                <img
                  v-else
                  :src="student.sex == 10 ? boyUserImgUrl : girlUserImgUrl"
                />
                <span class="name">{{ student.userName }}</span>
              </div>
              <div class="right-side">
                <span
                  v-if="student.score || student.score == 0"
                  class="score"
                  >{{ student.score }}</span
                >
                <span v-if="student.score || student.score == 0">分</span>
                <i v-else class="icon-box">
                  <icon-base
                    class="un-scored-icon"
                    :icon-name="Icons.unScored.iconName"
                    v-bind="Icons.unScored"
                  >
                    <un-scored-icon class="path-icon-info-help" />
                  </icon-base>
                </i>
              </div>
            </li>
          </ul>
          <div class="pagination">
            <el-pagination
              v-if="pagination.TotalCount"
              class="course-pagination"
              background
              layout="prev, pager, next"
              :page-size="pagination.PageSize"
              :current-page="pagination.PageIndex"
              :pager-count="pagination.count"
              :total="pagination.TotalCount"
              @current-change="changePageIndex"
            ></el-pagination>
          </div>
        </el-tab-pane>
        <el-tab-pane label="未提交" name="second">
          <ul class="published-list">
            <li
              class="list-item un-permit"
              v-for="(student, index) in studentList"
              :key="index"
            >
              <div class="left-side">
                <img v-if="student.photo" :src="/^(https?:\/\/)/.test(student.photo) ? student.photo : photoBaseUrl + student.photo" />
                <img
                  v-else
                  :src="student.sex == 10 ? boyUserImgUrl : girlUserImgUrl"
                />
                <span class="name">{{ student.userName }}</span>
              </div>
              <div class="right-side">
                <i class="icon-box">
                  <icon-base
                    class="un-scored-icon"
                    :icon-name="Icons.unScored.iconName"
                    v-bind="Icons.unScored"
                  >
                    <un-scored-icon class="path-icon-info-help" />
                  </icon-base>
                </i>
              </div>
            </li>
          </ul>
          <div class="pagination">
            <el-pagination
              v-if="pagination_2.TotalCount"
              class="course-pagination"
              background
              layout="prev, pager, next"
              :page-size="pagination_2.PageSize"
              :current-page="pagination_2.PageIndex"
              :pager-count="pagination_2.count"
              :total="pagination_2.TotalCount"
              @current-change="changePageIndex_2"
            ></el-pagination>
          </div>
        </el-tab-pane>
      </el-tabs>
    </div>
  </div>
</template>

<script>
import MARKCENTER from '@/axios/trainingCenter/MarkCenter/MarkCenter.js'
import PROJECTS from '@/axios/trainingCenter/projects/projects.js'
//载入为提交图标
import UnScoredIcon from '@/components/icons/typography/UnScoredIcon'
import { mapGetters } from 'vuex'

export default {
  name: 'publish-list',
  components: { UnScoredIcon },
  data() {
    return {
      photoBaseUrl: window.gtaAiConfig.photoDomain, // 资源平台上传接口基地址
      curriculumId: '',
      type: null,
      editorType: '',
      quoteTrainingId: '',
      traningTypes: [],
      isLogin: null,
      activeName: 'first',
      Status: 1, //1为已提交，0 为未提交
      CourseHourId: null,
      pagination: {
        count: 7,
        PageSize: 20,
        PageIndex: 1,
        TotalCount: 0,
      },
      pagination_2: {
        count: 7,
        PageSize: 20,
        PageIndex: 1,
        TotalCount: 0,
      },
      Icons: {
        unScored: {
          iconName: '',
          viewBox: '0 0 23 23',
          width: '23',
          height: '23',
          // iconColor: "#fff"
        },
      },
      studentList: [],
      UserImgUrl: require('../../../../public/images/img10.png'),
      boyUserImgUrl: require('@/assets/images/trainingCenter/boy-portrait.png'),
      girlUserImgUrl: require('@/assets/images/trainingCenter/girl-portrait.png'),
    }
  },
  watch: {},
  computed: {
    ...mapGetters(['token', 'userType']),
  },
  created() {
    let CourseHourId = this.$route.params.CourseHourId
    if (CourseHourId) sessionStorage.CourseHourId = CourseHourId
    this.CourseHourId = sessionStorage.CourseHourId
    this.GetTrainingUser() //获取学生列表 
    this.getTrainingTypeApi();
    if (this.$route.query) {
      this.curriculumId = this.$route.query.curriculumId
      this.editorType = this.$route.query.editorType
      this.type = this.$route.query.type
      this.quoteTrainingId = this.$route.query.quoteTrainingId
    }
  },
  mounted() {},
  methods: {
    // 返回实训目录
    onBack() {
      this.$router.back()
    },
    doCancelLogin() {
      this.isLogin = ''
    },
    doConfirmlLogin() {
      // this.isLogin = "login";
      // this.hasLogin = true;
    },
    handleClick(tab, event) {
      if (tab.name == 'second') {
        this.Status = 0
      } else if (tab.name == 'first') {
        this.Status = 1
      }

      this.GetTrainingUser() //获取学生列表
    },
    toScore(item) {
      let { type } = this
      if (type == 3) {
        // 实训模型页面
        this.$router.push({
          name: 'training-model',
          query: {
            trainingId: item.trainingId,
            userId: item.createBy,
            studentId: item.createBy,
            taskId: item.taskId,
            modelType: this.editorType,
          },
        })
      } else {
        // 积木页面
        this.redirectToProject(item)
      }
    },
    //实训-重定向到不同类别的编辑器
    redirectToProject(project) {
      let { editorType, type, curriculumId } = this
      let dictTypeDesc, queryName
      this.traningTypes.forEach((item) => {
        if (item.dictId == editorType) {
          dictTypeDesc = item.dictTypeDesc
        }
      })
      // console.log('this.traningTypes', this.traningTypes)
      if (/(?=.*AI-T).*(?=.积木模式)/i.test(dictTypeDesc)) {
        queryName = 'training-editor-block'
      } else if (/AI-T/i.test(dictTypeDesc)) {
        queryName = 'training-editor-ai-python'
      } else if (/海龟|基础/i.test(dictTypeDesc)) {
        queryName = 'training-editor-baseBlock'
      }
      this.$router.push({
        name: queryName,
        query: {
          trainingId: project.trainingId,
          trainingName: project.trainingName,
          type: type,
          editorType: editorType,
          curriculumId: curriculumId,
          createBy: project.createBy,
          studentId: project.userId,
          scoreHandle: true,
          quoteTrainingId: this.quoteTrainingId,
        },
      })
    },
    // 查询实训项目编辑方式
    getTrainingTypeApi() {
      let data = {
        dictTypeCode: 'EditorType',
      }
      return PROJECTS.getTrainingType(data)
        .then((res) => {
          if (res && res.returnCode == 200) {
            this.traningTypes = res.data
          }
        })
        .catch((err) => {
          console.log(err)
        })
    },
    changePageIndex(currentPage) {
      this.pagination.PageIndex = currentPage
      this.GetTrainingUser()
    },
    changePageIndex_2(currentPage) {
      this.pagination_2.PageIndex = currentPage
      this.GetTrainingUser()
    },
    // 获取学习一门课时实训的学生列表
    async GetTrainingUser() {
      let Status = this.Status,
        // CourseHourId = this.CourseHourId,
        trainingId = this.$route.query.trainingId,
        data = {
          isSubmit: Status, // 是否提交 1-已提交，0-未提交
          pageNum: 1, // 当前页数
          pageSize: 20, // 每页条数
          trainingId: trainingId, // 实训id
        }
      //分页返回
      if (Status == 1) {
        data.pageNum = this.pagination.PageIndex
        data.pageSize = this.pagination.PageSize
      } else {
        data.pageNum = this.pagination_2.PageIndex
        data.pageSize = this.pagination_2.PageSize
      }
      let res = await MARKCENTER.getTaskByTrainingId(data)
      if (!res || !res.isSuccess) {
        this.$message.error(res.errorMsg) //不成功时提示
      } else {
        if (res.data) {
          this.studentList = res.data.records
          if (Status == 1) {
            this.pagination.TotalCount = res.data.total
          } else {
            this.pagination_2.TotalCount = res.data.total
          }
        } else {
          this.studentList = []
        }
        return res.data
      }
    },
  }, //methods end
}
</script>

<style lang="scss" scoped>
$head_height: 80px;
$blockly_editer_left: rgba(13, 22, 53, 0.5);
$blockly_editer_left_select: rgba(94, 147, 255, 0.1);
$bg_area_right: rgba(94, 147, 255, 0.1);
$bg_tool_button: rgba(103, 140, 255, 0.15);
$height_sidebar_item: calc(50% - 80px);
$primary-bg: #4c88ff;
$btn_size: 14px;
$primary-color: #4c88ff;
$second-color: #9da9c0;
$normal-color: #333;
$border-color: #dfe6f4;
$warn-color: #fe5858;
div {
  box-sizing: border-box;
}
@mixin gradient-bg {
  background-image: linear-gradient(to right, #618aff, #8c6bf9);
}
@mixin flex-between {
  flex: 1;
  display: flex;
  justify-content: space-between;
  align-items: center;
}
@mixin flex-start {
  flex: 1;
  display: flex;
  justify-content: start;
  align-items: center;
}
@mixin card-shadow {
  box-shadow: 2px 5px 5px #dfe6f4;
}
.active-item {
  border: 1px solid $primary-bg;
  border-left: 5px solid $primary-bg;
}
@mixin hover {
  box-shadow: 0 2px 10px 0 #e3e4e6;
  transform: translateY(-4px);
  border: 1px solid $primary-bg;
  border-left: 5px solid $primary-bg;
  box-shadow: 1px 1px 8px $primary-bg;
  transition: all 0.5s;
  cursor: pointer;
}
.publish-list-section {
  min-height: 100%;
  // height: 100%;
  background-color: #f2f5fc;
  background-size: cover;
  background-position: center;
  color: $font_color_1st;
  padding-top: 80px;
  .nav-bg {
    background: url('../../../../public/images/personal-bg.jpg');
    width: 100%;
    height: 100px;
    background-size: cover;
    position: absolute;
  }
  .content {
    width: 1200px;
    padding-bottom: 50px;
    margin: 0 auto;
    position: relative;
    .back-button {
      font-size: 18px;
      color: #4C88FF;
      position: absolute;
      top: 65px;
      right: 20px;
      z-index: 3;
      display: flex;
      align-items: center;
      cursor: pointer;
      .icon-back {
        width: 21px;
        height: 17px;
        background: url("../../../../public/images/icon-back.png") no-repeat;
        background-size: 100% 100%;
        margin-right: 5px;
      }
    }
    .create-btn {
      cursor: pointer;
      width: 150px;
      height: 50px;
      position: absolute;
      margin-left: 1050px;
      font-size: $btn_size;
      color: #666;
      @include gradient-bg;
      z-index: 2;
      border-radius: 5px;
      text-align: center;
      line-height: 50px;
      color: #fff;
      font-size: 19px;
    }
    .list-tabs {
      position: relative;
      &::v-deep.el-tabs--card > .el-tabs__header {
        border-bottom: 1px solid #d9deea;
        position: absolute;
        top: 51px;
        width: 100%;
        .el-tabs__nav {
          border: none;
          .el-tabs__item {
            border: 1px solid #d9deea;
            height: 50px;
            line-height: 50px;
            padding-left: 30px !important;
            padding-right: 30px !important;
            background: #fff;
            margin-right: 8px;
            border-top-left-radius: 10px;
            border-top-right-radius: 10px;
            font-size: 18px;
            color: #333;
            &.is-active {
              background: #4c88ff;
              color: #fff;
            }
          }
        }
      }
    }
  }
}

.publish-list-section .list-tabs .published-list {
  width: 1200px;
  @include flex-start;
  flex-flow: wrap;
  margin-top: 160px;

  .list-item {
    display: flex;
    width: 270px;
    height: 70px;
    margin-bottom: 40px;
    margin-right: 20px;
    color: $normal-color;
    border: 1px solid $border-color;
    border-left: 5px solid $border-color;
    background: #fff;
    transition: all 0.5s;
    .un-permit {
      pointer-events: none;
    }
    &:hover {
      @include hover;
    }
    @include card-shadow;
    .left-side {
      width: 200px;
      @include flex-start;
      font-size: 16px;
      .name {
        width: 75px;
        overflow: hidden;
        white-space: nowrap;
        text-overflow: ellipsis;
      }
      img {
        width: 50px;
        height: 50px;
        margin: 0 15px;
      }
    }
    .right-side {
      // width: 100px;
      height: 70px;
      line-height: 70px;
      font-size: 16px;
      text-align: right;
      padding-right: 15px;
      .score {
        color: $primary-color;
        font-size: 28px;
        margin-right: 5px;
      }
      .icon-box {
        display: inline-block;
        height: 70px;
        line-height: 80px;
        vertical-align: middle;
      }
    }
  }
}
.pagination {
  position: fixed;
  left: 0;
  right: 0;
  bottom: 40px;
  margin: auto;
  .course-pagination {
    text-align: center;
  }
}
</style>
